import { JobsiteWorker } from 'apollo/generated/client-operations';
import { SearchWorkerResult } from 'components/searchBox/types';

/** The worker's jobsite worker on `jobsiteId`, or their first one when they are not on it. */
export const getJobsiteWorkerForJobsite = (
  searchWorkerResult: SearchWorkerResult,
  jobsiteId: string,
): JobsiteWorker => {
  const { jobsitesInfo } = searchWorkerResult;
  return (
    jobsitesInfo.find(
      (ji) =>
        ji.jobsiteWorker.jobsiteContractor.jobsite.jobsiteId === jobsiteId,
    )?.jobsiteWorker ?? jobsitesInfo[0]?.jobsiteWorker
  );
};
